import * as React from "react"
import PropTypes from "prop-types"
import Link from "../components/Link"
import CallButton from "./UI/CallButton"

const Footer = ({ siteTitle }) => (
  <footer>
    <div className="content-wide">
      <div className="wide-container">
        <div className="wide-inner">
          <div className="four-col">
            <div className="box">
              <h4>Legal</h4>
              <Link to="/impressum/">Impressum</Link>
              <br />
              <Link to="/cookie-policy/">Cookie Policy</Link>
              <br />
              <Link
                to="/pdf/Datenschutzerklarung_Website_V2.pdf"
                target="_blank"
              >
                Datenschutzerklärung für website
              </Link>
              <br />
              <Link
                to="https://nova.emento.dk/central/privacyPolicy?lang=en"
                target="_blank"
              >
                Datenschutzerklärung für app
              </Link>
            </div>
            <div className="box">
              <h4>Datenschutz</h4>
              <Link
                to="https://www.emento.dk/pdf/Emento_AS_ISAE_3000_GDPR_FSR__Type_2.pdf"
                target="_blank"
              >
                ISAE 3000 - GDPR
              </Link>
              <br />
              <Link
                to="https://www.emento.dk/pdf/Emento_AS__ISAE_3402_Type_2.pdf"
                target="_blank"
              >
                ISAE 3402 II
              </Link>
              <br />
              <p>
                Wenn Sie Fragen zur Datenschutzgrundverordnung haben, wenden Sie
                sich bitte an Michael Menge unter der unten angegebenen
                E-Mail-Adresse:
              </p>
              <p>
                <a href="mailto:mm@emento.de">mm@emento.de</a>
              </p>
            </div>
            <div className="box">
              <h4>Kontakt</h4>
              <b>Christos Mantzaridis</b>
              <br />
              Geschäftsführer / CEO
              <br />
              Email: <a href="mailto:kontakt@emento.de">kontakt@emento.de</a>
              <br />
              Phone: <CallButton />
              <br />
              <br />
              <a
                href="https://goo.gl/maps/JqAwyP66fmhjLc2N6"
                target="_blank"
                rel="noreferrer"
              >
                <b>Emento GmbH</b>
              </a>
              <br />
              Am Gierath 20 A
              <br />
              40885 Ratingen
              <br />
            </div>
            <div className="box">
              <h4>Links</h4>
              <Link to="/faq-patient/">FAQ für Patienten</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="disclaimer">
      © {new Date().getFullYear()}, Built by
      {` `}
      <Link to="https://www.emento.de">Emento</Link>
    </div>
  </footer>
)

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
}

export default Footer
